var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUsed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Cards/Groups/Hover") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/Cards/Groups/Hover",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#A12885",
    fillRule: "nonzero",
    cx: 40,
    cy: 40,
    r: 40
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(20.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 40 0 40 40 0 40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6666667,18.3333333 C29.4333333,18.3333333 31.65,16.1 31.65,13.3333333 C31.65,10.5666667 29.4333333,8.33333333 26.6666667,8.33333333 C23.9,8.33333333 21.6666667,10.5666667 21.6666667,13.3333333 C21.6666667,16.1 23.9,18.3333333 26.6666667,18.3333333 Z M13.3333333,18.3333333 C16.1,18.3333333 18.3166667,16.1 18.3166667,13.3333333 C18.3166667,10.5666667 16.1,8.33333333 13.3333333,8.33333333 C10.5666667,8.33333333 8.33333333,10.5666667 8.33333333,13.3333333 C8.33333333,16.1 10.5666667,18.3333333 13.3333333,18.3333333 Z M13.3333333,21.6666667 C9.45,21.6666667 1.66666667,23.6166667 1.66666667,27.5 L1.66666667,30 C1.66666667,30.9166667 2.41666667,31.6666667 3.33333333,31.6666667 L23.3333333,31.6666667 C24.25,31.6666667 25,30.9166667 25,30 L25,27.5 C25,23.6166667 17.2166667,21.6666667 13.3333333,21.6666667 Z M26.6666667,21.6666667 C26.1833333,21.6666667 25.6333333,21.7 25.05,21.75 C25.0833333,21.7666667 25.1,21.8 25.1166667,21.8166667 C27.0166667,23.2 28.3333333,25.05 28.3333333,27.5 L28.3333333,30 C28.3333333,30.5833333 28.2166667,31.15 28.0333333,31.6666667 L36.6666667,31.6666667 C37.5833333,31.6666667 38.3333333,30.9166667 38.3333333,30 L38.3333333,27.5 C38.3333333,23.6166667 30.55,21.6666667 26.6666667,21.6666667 Z",
    id: "Shape",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsed);
export default __webpack_public_path__ + "static/media/used.f758cf88d80ce3aad594c871c832b6b1.svg";
export { ForwardRef as ReactComponent };